import {
  GetTaskSettingByTaskType,
  GetTaskBusinessByTaskId,
  GetTaskStateSettingByTaskType
} from '@/api/modules/basicData/basicTask.js'

//TODO:获取任务详情组件名称
export function GetTaskDetailComponentName(tasktype, taskclass) {
  return GetTaskSettingByTaskType(tasktype, taskclass).then(o => {
    if (o) return o.DETAILINFO
    else return 'div'
  })
}

//TODO:获取任务审批组件名称
export function GetTaskInvokeComponentName(tasktype, taskclass, taskstate) {
  return GetTaskStateSettingByTaskType(tasktype, taskclass, taskstate).then(
    o => {
      if (o) return o.INVOKEINFO
      else return 'div'
    }
  )
}
